import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import {
  setUnblockNumberState,
  unblockPhoneNumber as unblockPhoneNumberAction,
} from "./actions";
import { getUnblockNumberState } from "./selectors";

export default function UnblockConfirmaton() {
  const { confirmUnblockNumber } = useSelector((state) =>
    getUnblockNumberState(state)
  );
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(
      setUnblockNumberState({
        confirmUnblockNumber: false,
        unblockAccountId: null,
        unblockPhoneNumber: null,
      })
    );
  };
  return (
    <Dialog open={confirmUnblockNumber} onClose={handleClose}>
      <DialogTitle>Unblock Phone Number</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to unblock ?
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ paddingLeft: 20, paddingRight: 20 }}>
        <Button onClick={() => dispatch(unblockPhoneNumberAction())}>
          Unblock
        </Button>
        <Button onClick={handleClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
